export const PAGE_BREAKPOINT_SM = 480
export const PAGE_BREAKPOINT_MD = 768
export const PAGE_BREAKPOINT_DESK = 1280
export const PAGE_BREAKPOINT_XL = 1440
export const PAGE_BREAKPOINT_FHD = 1920

export const ALL_LANGUAGES_AVAILABLE = ["en", "es", "de"]

export const PATRICK_CALENDAR_URL =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3ljkycU_cO-qHJogHw-AwWwxnQ7USdA8PMMEyNntJ1JU8KAWiuyIbWNuC5maRki-25iTkiyWpn"
